import { ENV } from '@/constants';

export const schemaObject_Tools = {
	'@context': 'https://schema.org',
	'@graph': [
		{
			'@type': 'WebPage',
			'@id': 'https://liftapp.ai/tools',
			name: 'Create, edit & enhance visual content with AI',
			description: 'Create, edit & enhance visual content with AI',

			mainEntity: [
				{ '@id': 'https://liftapp.ai/tools#ai-tools' },
				{ '@id': 'https://liftapp.ai/tools#faq' },
				{ '@id': 'https://liftapp.ai/tools#all-in-one' },
			],
		},

		{
			'@type': 'Product',
			'@id': 'https://liftapp.ai/tools',
			name: 'Create, edit & enhance visual content with AI',
			description:
				'Lift’s AI Tools let you create stunning visuals, remove backgrounds, upscale photos, and more — all in your browser.',
			brand: {
				'@type': 'Brand',
				name: 'Lift',
				image: 'https://liftapp.ai/seo-image.webp',
			},
			aggregateRating: {
				'@type': 'AggregateRating',
				ratingValue: '4.8',
				reviewCount: 130000,
				bestRating: '5',
				worstRating: '1',
			},
			interactionStatistic: [
				{
					'@type': 'InteractionCounter',
					interactionType: { '@type': 'InstallAction' },
					userInteractionCount: 13000000,
				},
			],
		},

		{
			'@type': 'ItemList',
			'@id': 'https://liftapp.ai/tools#ai-tools',
			name: 'Lift AI Tools Grid',
			description:
				"Explore Lift's collection of AI tools for image generation, enhancement, and creative filters.",
			itemListElement: [
				{
					'@type': 'SoftwareApplication',
					operatingSystem: 'Web',
					applicationCategory: 'MultimediaApplication',
					'@id': 'https://liftapp.ai/clothes-changer',
					name: 'AI Clothes Changer',
					description: "Try on new outfits with Lift's AI Clothes Changer",
					url: 'https://liftapp.ai/clothes-changer',
					brand: { '@type': 'Brand', name: 'Lift' },
					position: 25,
				},
				{
					'@type': 'SoftwareApplication',
					operatingSystem: 'Web',
					applicationCategory: 'MultimediaApplication',
					'@id': 'https://liftapp.ai/increase-image-quality',
					name: 'AI Image Quality Improver',
					description: 'Increase image quality with AI',
					url: 'https://liftapp.ai/increase-image-quality',
					brand: { '@type': 'Brand', name: 'Lift' },
					position: 24,
				},
				{
					'@type': 'SoftwareApplication',
					operatingSystem: 'Web',
					applicationCategory: 'MultimediaApplication',
					'@id': 'https://liftapp.ai/image-sharpener',
					name: 'AI Image Sharpener',
					description: 'Sharpen blurry photos instantly',
					url: 'https://liftapp.ai/image-sharpener',
					brand: { '@type': 'Brand', name: 'Lift' },
					position: 23,
				},
				{
					'@type': 'SoftwareApplication',
					operatingSystem: 'Web',
					applicationCategory: 'MultimediaApplication',
					'@id': 'https://liftapp.ai/unblur-image',
					name: 'Image Unblur Tool',
					description: 'Unblur pictures online with AI.',
					url: 'https://liftapp.ai/unblur-image',
					brand: { '@type': 'Brand', name: 'Lift' },
					position: 22,
				},

				{
					'@type': 'SoftwareApplication',
					operatingSystem: 'Web',
					applicationCategory: 'MultimediaApplication',
					'@id': 'https://liftapp.ai/image-denoiser',
					name: 'AI Image Denoiser',
					description: 'Remove noise from photos instantly',
					url: 'https://liftapp.ai/image-denoiser',
					brand: { '@type': 'Brand', name: 'Lift' },
					position: 21,
				},
				{
					'@type': 'SoftwareApplication',
					operatingSystem: 'Web',
					applicationCategory: 'MultimediaApplication',
					'@id': 'https://liftapp.ai/resolution-increaser',
					name: 'AI Resolution Increaser',
					description: 'Enhance image resolution instantly',
					url: 'https://liftapp.ai/resolution-increaser',
					brand: { '@type': 'Brand', name: 'Lift' },
					position: 19,
				},
				{
					'@type': 'SoftwareApplication',
					operatingSystem: 'Web',
					applicationCategory: 'MultimediaApplication',
					'@id': 'https://liftapp.ai/image-enlarger',
					name: 'AI Image Enlarger',
					description: 'Enlarge photos with AI',
					url: 'https://liftapp.ai/image-enlarger',
					brand: { '@type': 'Brand', name: 'Lift' },
					position: 18,
				},
				{
					'@type': 'SoftwareApplication',
					operatingSystem: 'Web',
					applicationCategory: 'MultimediaApplication',
					'@id': 'https://liftapp.ai/hd-photo-converter',
					name: 'HD Photo Converter',
					description: 'Convert image quality with AI',
					url: 'https://liftapp.ai/hd-photo-converter',
					brand: { '@type': 'Brand', name: 'Lift' },
					position: 17,
				},
				{
					'@type': 'SoftwareApplication',
					operatingSystem: 'Web',
					applicationCategory: 'MultimediaApplication',
					'@id': 'https://liftapp.ai/photo-restoration',
					name: 'Old Photo Restoration AI',
					description: 'Restore old photos with AI',
					url: 'https://liftapp.ai/photo-restoration',
					brand: { '@type': 'Brand', name: 'Lift' },
					position: 16,
				},
				{
					'@type': 'SoftwareApplication',
					operatingSystem: 'Web',
					applicationCategory: 'MultimediaApplication',
					'@id': 'https://liftapp.ai/unpixelate-image',
					name: 'AI Image Depixelizer',
					description: 'Remove pixelation from images instantly with AI',
					url: 'https://liftapp.ai/unpixelate-image',
					brand: { '@type': 'Brand', name: 'Lift' },
					position: 15,
				},
				{
					'@type': 'SoftwareApplication',
					operatingSystem: 'Web',
					applicationCategory: 'MultimediaApplication',
					'@id': 'https://liftapp.ai/ai-hairstyle-changer',
					name: 'AI Hairstyle Changer',
					description: 'Change your hair style with AI',
					url: 'https://liftapp.ai/ai-hairstyle-changer',
					brand: { '@type': 'Brand', name: 'Lift' },
					position: 14,
				},
				{
					'@type': 'SoftwareApplication',
					operatingSystem: 'Web',
					applicationCategory: 'MultimediaApplication',
					'@id': 'https://liftapp.ai/cartoon-generator',
					name: 'AI Cartoon Generator',
					description: 'Turn your photos into unique cartoons with AI',
					url: 'https://liftapp.ai/cartoon-generator',
					brand: { '@type': 'Brand', name: 'Lift' },
					position: 12,
				},
				{
					'@type': 'SoftwareApplication',
					operatingSystem: 'Web',
					applicationCategory: 'MultimediaApplication',
					'@id': 'https://liftapp.ai/anime-generator',
					name: 'AI Anime Generator',
					description: 'Generate stunning AI anime art from your photos',
					url: 'https://liftapp.ai/anime-generator',
					brand: { '@type': 'Brand', name: 'Lift' },
					position: 11,
				},
				{
					'@type': 'SoftwareApplication',
					operatingSystem: 'Web',
					applicationCategory: 'MultimediaApplication',
					'@id': 'https://liftapp.ai/headshot-generator',
					name: 'AI Headshot generator',
					description: 'Professional headshot created with AI',
					url: 'https://liftapp.ai/headshot-generator',
					brand: { '@type': 'Brand', name: 'Lift' },
					position: 14,
				},
				{
					'@type': 'SoftwareApplication',
					operatingSystem: 'Web',
					applicationCategory: 'MultimediaApplication',
					'@id': 'https://liftapp.ai/image-extender',
					name: 'AI Image Extender',
					description: 'Uncrop your images with AI',
					url: 'https://liftapp.ai/image-extender',
					brand: { '@type': 'Brand', name: 'Lift' },
					position: 13,
				},
				{
					'@type': 'SoftwareApplication',
					operatingSystem: 'Web',
					applicationCategory: 'MultimediaApplication',
					'@id': 'https://liftapp.ai/cartoon-generator',
					name: 'AI Cartoon generator',
					description: 'Turn your photos into unique cartoons with AI',
					url: 'https://liftapp.ai/cartoon-generator',
					brand: { '@type': 'Brand', name: 'Lift' },
					position: 12,
				},
				{
					'@type': 'SoftwareApplication',
					operatingSystem: 'Web',
					applicationCategory: 'MultimediaApplication',
					'@id': 'https://liftapp.ai/anime-generator',
					name: 'AI Anime generator',
					description: 'Generate stunning AI anime art from your photos',
					url: 'https://liftapp.ai/anime-generator',
					brand: { '@type': 'Brand', name: 'Lift' },
					position: 11,
				},
				{
					'@type': 'SoftwareApplication',
					operatingSystem: 'Web',
					applicationCategory: 'MultimediaApplication',
					'@id': 'https://liftapp.ai/watermark-remover',
					name: 'AI Watermark Remover',
					description: 'Remove watermark from images using AI',
					url: 'https://liftapp.ai/watermark-remover',
					brand: { '@type': 'Brand', name: 'Lift' },
					position: 10,
				},
				{
					'@type': 'SoftwareApplication',
					operatingSystem: 'Web',
					applicationCategory: 'MultimediaApplication',
					'@id': 'https://liftapp.ai/headshot-generator',
					name: 'AI Headshot Generator',
					description: 'Professional headshot created with AI',
					url: 'https://liftapp.ai/headshot-generator',
					brand: { '@type': 'Brand', name: 'Lift' },
					position: 9,
				},
				{
					'@type': 'SoftwareApplication',
					operatingSystem: 'Web',
					applicationCategory: 'MultimediaApplication',
					'@id': 'https://liftapp.ai/image-gen',
					name: 'AI Image Generator',
					description: 'Generate images from text prompts using AI',
					url: 'https://liftapp.ai/image-gen',
					brand: { '@type': 'Brand', name: 'Lift' },
					position: 8,
				},
				{
					'@type': 'SoftwareApplication',
					operatingSystem: 'Web',
					applicationCategory: 'MultimediaApplication',
					'@id': 'https://liftapp.ai/image-upscaler',
					name: 'AI Image Upscaler',
					description: 'Upscale low-res photos to 4K with one click',
					url: 'https://liftapp.ai/image-upscaler',
					brand: { '@type': 'Brand', name: 'Lift' },
					position: 7,
				},
				{
					'@type': 'SoftwareApplication',
					operatingSystem: 'Web',
					applicationCategory: 'MultimediaApplication',
					'@id': 'https://liftapp.ai/image-enhancer',
					name: 'AI Image Enhancer',
					description: 'Enhance image clarity, contrast and color',
					url: 'https://liftapp.ai/image-enhancer',
					brand: { '@type': 'Brand', name: 'Lift' },
					position: 6,
				},
				{
					'@type': 'SoftwareApplication',
					operatingSystem: 'Web',
					applicationCategory: 'MultimediaApplication',
					'@id': 'https://liftapp.ai/background-remover',
					name: 'AI Background Remover',
					description: 'Remove image backgrounds in seconds',
					url: 'https://liftapp.ai/background-remover',
					brand: { '@type': 'Brand', name: 'Lift' },
					position: 5,
				},
				{
					'@type': 'SoftwareApplication',
					operatingSystem: 'Web',
					applicationCategory: 'MultimediaApplication',
					'@id': 'https://liftapp.ai/object-remover',
					name: 'AI Object Remover',
					description: 'Erase unwanted objects from photos',
					url: 'https://liftapp.ai/object-remover',
					brand: { '@type': 'Brand', name: 'Lift' },
					position: 4,
				},
				{
					'@type': 'SoftwareApplication',
					operatingSystem: 'Web',
					applicationCategory: 'MultimediaApplication',
					'@id': 'https://liftapp.ai/ai-filters-starter-pack',
					name: 'AI Starter Pack generator',
					description: 'Apply aesthetic filters to your photos',
					url: 'https://liftapp.ai/ai-filters-starter-pack',
					brand: { '@type': 'Brand', name: 'Lift' },
					position: 3,
				},
				{
					'@type': 'SoftwareApplication',
					operatingSystem: 'Web',
					applicationCategory: 'MultimediaApplication',
					'@id': 'https://liftapp.ai/ai-filters-lego',
					name: 'AI LEGO generator',
					description: 'Turn images into LEGO-style illustrations',
					url: 'https://liftapp.ai/ai-filters-lego',
					brand: { '@type': 'Brand', name: 'Lift' },
					position: 2,
				},
				{
					'@type': 'SoftwareApplication',
					operatingSystem: 'Web',
					applicationCategory: 'MultimediaApplication',
					'@id': 'https://liftapp.ai/ai-filters-ghibli',
					name: 'AI Ghibli generator',
					description: 'Transform photos into Ghibli-style art',
					url: 'https://liftapp.ai/ai-filters-ghibli',
					brand: { '@type': 'Brand', name: 'Lift' },
					position: 1,
				},
			],
		},

		{
			'@type': 'FAQPage',
			'@id': 'https://liftapp.ai/tools#faq',
			mainEntity: [
				{
					'@type': 'Question',
					name: 'What is Lift AI?',
					acceptedAnswer: {
						'@type': 'Answer',
						text: 'Lift is an all-in-one creative platform that lets you generate images from text and edit them instantly — all in your browser. Whether you want to turn ideas into visuals or fine-tune photos for business, Lift brings powerful AI tools and classic editing features together in one place.',
					},
				},
				{
					'@type': 'Question',
					name: 'How does Lift work for both generating and editing images?',
					acceptedAnswer: {
						'@type': 'Answer',
						text: 'It’s simple: start by typing a prompt to generate an image in your chosen style (3D, cartoon, Ghibli, realistic, etc.) — or upload an existing photo. Then, use the built-in editor to enhance, resize, remove objects or backgrounds, apply filters, and more. Everything is cloud-based, no app or design skills needed.',
					},
				},
				{
					'@type': 'Question',
					name: 'Can it improve quality and fix image flaws?',
					acceptedAnswer: {
						'@type': 'Answer',
						text: 'Yes. Whether you generate an image or upload your own, Lift can enhance it with one click — fixing blur, lighting, color, and resolution. You can also remove unwanted objects or backgrounds for cleaner, more professional results.',
					},
				},
				{
					'@type': 'Question',
					name: 'Can I download the results without a watermark?',
					acceptedAnswer: {
						'@type': 'Answer',
						text: "Absolutely. All images generated or edited in Lift can be exported without watermark when you're on the Pro plan. Download them in high-res PNG or JPG — ready for social media, print, ads, or e-commerce.",
					},
				},
			],
		},

		{
			'@type': 'SoftwareApplication',
			'@id': 'https://liftapp.ai/tools#all-in-one',
			name: 'Try Lift – AI Content Creation Tools',
			description:
				'Your all-in-one tools to create, edit, and elevate your content. Create stunning content with AI tools, templates, and editing features effortlessly.',
			operatingSystem: 'iOS, Android, Web',
			applicationCategory: 'MultimediaApplication',
			url: `${ENV.LIFT_WEB_APP_URL}/sign-in?auto_login=true`,
			applicationSubCategory: 'Content Creation',
			publisher: {
				'@type': 'Organization',
				name: 'Lift',
				url: 'https://liftapp.ai',
			},
			potentialAction: [
				{
					'@type': 'ViewAction',
					name: 'Open Web App',
					target: `${ENV.LIFT_WEB_APP_URL}/sign-in?auto_login=true`,
				},
			],
		},

		{
			'@type': 'BreadcrumbList',
			itemListElement: [
				{
					'@type': 'ListItem',
					position: 1,
					name: 'Home',
					item: 'https://liftapp.ai',
				},
				{
					'@type': 'ListItem',
					position: 2,
					name: 'AI Tools',
					item: 'https://liftapp.ai/tools',
				},
			],
		},
	],
};
